<template>
  <div class="index">
      <div v-for="(item,index) in mainData.plates" :key="index">
        <banner v-if="item.type ==1" :bannerData="item"></banner>
        <edu-platform v-if="item.type ==2"></edu-platform>
        <!--news-->
        <div v-if="item.type ==3">
          <edu-news-one v-if="item.style == 1" :newsData="item"></edu-news-one>
          <edu-news-one-style-one v-if="item.style == 4" :newsData="item"></edu-news-one-style-one>
          <edu-news-two v-if="item.style == 2" :newsData="item"></edu-news-two>
          <edu-news-two-style-two v-if="item.style == 5" :newsData="item"></edu-news-two-style-two>
          <edu-news-three v-if="item.style == 3" :newsData="item"></edu-news-three>
          <edu-news-three-style-three v-if="item.style == 6" :newsData="item"></edu-news-three-style-three>
        </div>
        <big-data v-if="item.type ==4" :bigData="item"></big-data>
        <!--resouse-->
        <div v-if="item.type ==5 && isshow">
          <micro @showPlayer="showPlayer" @isplay="isplay"></micro>
          <package></package>
        </div>
        <!--show-->
        <div v-if="item.type ==6">
          <teacher v-if="item.style ==1" :showData="item"></teacher>
          <index-school v-if="item.style ==2" :showData="item"></index-school>
          <blogroll v-if="item.style ==3" :showData="item"></blogroll>
        </div>
      </div>
      <!--弹窗-->
      <paly-material v-show="isPlayMaterial" @closePlayer="closePlayer"></paly-material>
      <video-player v-if="isPlayer" @closePlayer="closePlayer"></video-player>
      <login @cancelbtn="cancelbtn" v-if="isLoginMark"></login>

  </div>
</template>

<script>
import api from '../../utils/api.js'
import bus from '../../assets/eventBus/enentBus.js';
import Banner from '../indexContent/Banner.vue'
import eduPlatform from '../indexContent/eduPlatform.vue'
import eduNewsOne from '../indexContent/eduNewsOne.vue'
import eduNewsTwo from '../indexContent/eduNewsTwo.vue'
import eduNewsThree from '../indexContent/eduNewsThree.vue'
import eduNewsOneStyleOne from '../indexContent/eduNewsOneStyleOne.vue'
import eduNewsTwoStyleTwo from '../indexContent/eduNewsTwoStyleTwo.vue'
import eduNewsThreeStyleThree from '../indexContent/eduNewsThreeStyleThree.vue'
import bigData from '../indexContent/bigData.vue'
import micro from '../indexContent/microVideo.vue'
import Package from '../indexContent/package.vue'
import Teacher from '../indexContent/teacher.vue'
import indexSchool from '../indexContent/indexSchool.vue'
import Blogroll from '../indexContent/blogroll.vue'
import palyMaterial from '../playMaterial/playMaterial.vue'
import videoPlayer from '../videoPlayer/videoPlayer.vue'
import login from '../indexContent/login.vue'
export default {
  name: 'index',
  props:{
    mainData:{
      type:Object,
      default:null
    }
  },
  data () {
    return {
      type:1,
      isPlayer:false,
      isPlayMaterial:false,
      isLoginMark:false,
      value:'name1',
      isshow:false
    }
  },
  watch:{
      'mainData':{
        handler:function(newValue,oldValue){
          // console.log(newValue,oldValue,"sssssssssss")
          this.indexData = this.mainData.plates
          if(newValue!=oldValue) {

          }
        },
        deep:true
      }
  },
  mounted() {
    this.isshow = location.host === 'www.aixueyun.cn' ? false:true
  },
  methods:{
    isplay(msg){
        this.isPlayMaterial = msg;
    },
    showPlayer(obj){
        this.isPlayer = obj;            //打开播放器  ture
    },
    closePlayer(msg){
        this.isPlayMaterial = msg;
        this.isPlayer = msg;
    },
    cancelbtn(msg){
      this.isLoginMark = msg;
    }
  },
  components:{Banner,eduPlatform,eduNewsOne,eduNewsTwo,eduNewsThree,eduNewsOneStyleOne,eduNewsTwoStyleTwo,eduNewsThreeStyleThree,bigData,micro,Package,Teacher,indexSchool,Blogroll,videoPlayer,palyMaterial,login}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .yptmore {
    display: block;
  }
.yptmore img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue